import React from "react";
import { Button } from "@mui/material";

export default function ButtonComp(props: any) {
  const {
    variant,
    size,
    onClick,
    color,
    width,
    height,
    type,
    textTransform,
    fontSize,
    selected = false,
    children,
    disabled = false,
    sx = {},
  } = props;
  return (
    <div>
      <Button
        variant={variant}
        size={size}
        onClick={onClick}
        color={color}
        disabled={disabled}
        type={type}
        sx={{
          height,
          width,
          textTransform,
          fontSize,
          backgroundColor: disabled ? "#BDBDBD" : undefined, // grey[400]
          color: disabled ? "#fff" : undefined,
          "&:hover": {
            backgroundColor: disabled ? "#BDBDBD" : undefined,
          },
          ...sx, // allow custom overrides
        }}
      >
        {children}
      </Button>
    </div>
  );
}
